module.exports = __webpack_public_path__ + "static/5th-b10680026526c4426aa383b2dae22f02.png";